import Vue from 'vue'
import axios from 'axios'
import eventHub from '../helpers/event-hub'

if (document.getElementById('vue-jobs')) {
  new Vue({
    el: '#vue-jobs',
    data() {
      return {
        apiUrl: `${location.origin}/wp-json/orange-campus/v1/jobs`,
        loading: true,
        jobs: [],
        filters: {},
      }
    },
    created() {
        this.getJobs()
    },
    computed: {
    },
    methods: {
        getJobs() {
        this.loading = true

        axios
            .get(this.apiUrl, {
            params: {
                lang: document.getElementById('vue-jobs').dataset.lang
            }
            })
            .then(response => {
              this.jobs = response.data;
              this.loading = false;
            });
        },
        getJobThumbnail(job, size) {
            return job.image ? job.image.sizes[size] : ''
        },
    }
  })

}
